import React from "react";
import Icon from "./Icon";

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 50,
    width: '384px',
    backgroundColor: '#ffffff',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    overflow: 'hidden',
    animation: 'slideIn 0.3s ease-out'
  },
  header: {
    backgroundColor: '#f3f6fe',
    color: '#000000',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerTitle: {
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0.025em',
    margin: 0
  },
  headerButtons: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  stopButton: {
    backgroundColor: '#ffffff',
    color: '#ef4444',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '4px 12px',
    borderRadius: '9999px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  closeButton: {
    cursor: 'pointer',
    width: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000000',
    transition: 'color 0.2s'
  },
  body: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  customerSection: {
    marginBottom: '4px'
  },
  customerName: {
    color: '#1f2937',
    fontWeight: 600,
    fontSize: '16px',
    margin: 0
  },
  customerPhone: {
    color: '#6b7280',
    fontSize: '14px',
    margin: 0
  },
  addressSection: {
    marginBottom: '4px'
  },
  addressLabel: {
    fontSize: '12px',
    color: '#6b7280',
    margin: 0
  },
  addressText: {
    fontSize: '14px',
    color: '#374151',
    margin: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  orderInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f9fafb',
    padding: '12px',
    borderRadius: '12px'
  },
  infoItem: {
    flex: 1
  },
  infoLabel: {
    fontSize: '12px',
    color: '#6b7280',
    margin: 0
  },
  infoValue: {
    fontWeight: 600,
    margin: 0,
    fontSize: '14px'
  },
  amountValue: {
    color: '#16a34a'
  },
  paidValue: {
    color: '#2563eb'
  },
  viewOrderButton: {
    borderRadius: '8px',
    textAlign: 'center',
    color: '#1e40af',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: '#dbeafe',
    padding: '8px',
    fontSize: '12px',
    border: 'none',
    transition: 'background-color 0.2s'
  }
};

class NotificationBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredStop: false,
      hoveredViewOrder: false,
      hoveredClose: false
    };
    this.onViewOrderClick = this.onViewOrderClick.bind(this);
  }

  onViewOrderClick() {
    if (this.props.onClose) {
      this.props.onClose();
    }
      // old: the delivery list
      // this.props.history.push({ pathname: "/home/sales/deliverylist", state: { isRefresh: true } });
      this.props.history.push({ pathname: "/home/sales/whatsapporders" });
    
  }

  getSafeValue(obj, path, defaultValue) {
    const keys = path.split('.');
    let current = obj;
    
    for (let i = 0; i < keys.length; i++) {
      if (current === null || current === undefined) {
        return defaultValue;
      }
      if (typeof current === 'object' && Object.prototype.hasOwnProperty.call(current, keys[i])) {
        current = current[keys[i]];
      } else {
        return defaultValue;
      }
    }
    return current;
  }

  render() {
    const { data, onStop, visible, onClose } = this.props;
    
    if (!visible || !data) return null;

    // Safely access data properties
    const transactionNo = data.transactionNo || '';
    const customerName = data.customerName || '';
    const customerMobileNo = data.customerMobileNo || '';
    const billQty = data.billQty || '';
    const billAmount = data.billAmount || '';
    const billPaidAmount = data.billPaidAmount || '';
    
    // Safely access address
    let addressText = "N/A";
    if (data.deliveryCustomerAddress && typeof data.deliveryCustomerAddress === 'object') {
      const address = data.deliveryCustomerAddress;
      const address1 = address.Address1 || '';
      const address2 = address.Address2 || '';
      const city = address.City || '';
      const state = address.State || '';
      const postalCode = address.PostalCode || '';
      const country = address.Country || '';
      
      addressText = `${address1}${address2 ? ', ' + address2 : ''}${city ? ', ' + city : ''}${state ? ', ' + state : ''}${postalCode ? ' - ' + postalCode : ''}${country ? ', ' + country : ''}`;
      
      // Clean up empty parts
      addressText = addressText.replace(/^[, ]+/, '').replace(/[, ]+$/, '');
      if (!addressText) addressText = "N/A";
    }

    return (
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div>
            <p style={styles.headerTitle}>
              NEW {data.channel ? String(data.channel).toUpperCase() + " " : ""}ORDER #{transactionNo}
            </p>
          </div>
          
          <div style={styles.headerButtons}>
            <button
              onClick={onStop}
              style={{
                ...styles.stopButton,
                backgroundColor: this.state.hoveredStop ? '#fee2e2' : '#ffffff'
              }}
              onMouseEnter={() => this.setState({ hoveredStop: true })}
              onMouseLeave={() => this.setState({ hoveredStop: false })}
            >
             🔇
            </button>
            <span 
              style={{
                ...styles.closeButton,
                color: this.state.hoveredClose ? '#ef4444' : '#000000'
              }}
              onClick={onClose}
              onMouseEnter={() => this.setState({ hoveredClose: true })}
              onMouseLeave={() => this.setState({ hoveredClose: false })}
            >
              <Icon type="remove" />
            </span>
          </div>
        </div>

        {/* Body */}
        <div style={styles.body}>
          {/* Customer */}
          <div style={styles.customerSection}>
            <p style={styles.customerName}>
              {customerName}
            </p>
            <p style={styles.customerPhone}>
              📞 {customerMobileNo}
            </p>
          </div>
          
          {/* Address */}
          <div style={styles.addressSection}>
            <p style={styles.addressLabel}>Address</p>
            <p style={styles.addressText}>
              📍 {addressText}
            </p>
          </div>
          
          {/* Order Info */}
          <div style={styles.orderInfo}>
            <div style={styles.infoItem}>
              <p style={styles.infoLabel}>Items</p>
              <p style={styles.infoValue}>
                {billQty || 0}
              </p>
            </div>

            <div style={styles.infoItem}>
              <p style={styles.infoLabel}>Amount</p>
              <p style={{...styles.infoValue, ...styles.amountValue}}>
                ₹ {billAmount || 0}
              </p>
            </div>

            <div style={styles.infoItem}>
              <p style={styles.infoLabel}>Paid</p>
              <p style={{...styles.infoValue, ...styles.paidValue}}>
                ₹ {billPaidAmount || 0} 
              </p>
            </div>
          </div>
          
          {/* View Order Button */}
          <div 
            onClick={this.onViewOrderClick}
            style={{
              ...styles.viewOrderButton,
              backgroundColor: this.state.hoveredViewOrder ? '#bfdbfe' : '#dbeafe'
            }}
            onMouseEnter={() => this.setState({ hoveredViewOrder: true })}
            onMouseLeave={() => this.setState({ hoveredViewOrder: false })}
          >
            View Order
          </div>
        </div>

        {/* Add keyframe animation */}
        <style>
          {`
            @keyframes slideIn {
              from {
                transform: translateX(100%);
                opacity: 0;
              }
              to {
                transform: translateX(0);
                opacity: 1;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default NotificationBox;